/** A resource manager's decision on one operation (port of C# `Ruling`). */
export enum Ruling {
  Denied = 0,
  Allowed = 1,
  DontCare = 2,
}
